export default __webpack_public_path__ + "static/media/news_image.a8c8dd4a.png";